import { normalizeObject, dataLayerPush } from "./utils";
// donation Initiated Event Handler
var donationWidgetLoadedEventHandler = function (e) {
    var donationData = {};
    e && e.detail
        && Object.assign(donationData, normalizeObject(e.detail));
    // Event specific overwrites 
    Object.assign(donationData, {
        "event": "view_item",
        "event_action": "donation_widget_loaded",
        "event_category": "ecommerce",
        "donate_widget_checkout_type": "redirect",
        "non_interaction": true
    });
    dataLayerPush(donationData);
};
// donation Results View Event Handler
var donationAddToCartEventHandler = function (e) {
    var donationData = {};
    e && e.detail
        && Object.assign(donationData, normalizeObject(e.detail));
    // Event specific overwrites 
    Object.assign(donationData, {
        "event": "add_to_cart",
        "event_action": "add_to_cart",
        "event_category": "ecommerce",
        "donate_widget_checkout_type": "redirect",
        "high_intent_interactions": "1"
    });
    dataLayerPush(donationData);
};
export { donationWidgetLoadedEventHandler, donationAddToCartEventHandler };
